import type { LOB } from '@/utils/server/lob-utils';

export type LocalesType = {
    [key in LOB]: {
        [key: string]: string;
    };
};

// order default locale first for each group so that it's taken first if user's locale is regionless
export const regionToLocaleMap: LocalesType = {
    pplus: {
        de: 'de-de',
        at: 'de-de',
        ch: 'de-de',

        us: 'en-us',
        au: 'en-au',
        ca: 'en-ca',
        gb: 'en-gb',
        ie: 'en-ie',

        ar: 'es-419',
        bo: 'es-419',
        cl: 'es-419',
        co: 'es-419',
        cr: 'es-419',
        do: 'es-419',
        ec: 'es-419',
        gt: 'es-419',
        hn: 'es-419',
        mx: 'es-419',
        ni: 'es-419',
        pa: 'es-419',
        pe: 'es-419',
        py: 'es-419',
        sv: 'es-419',
        uy: 'es-419',
        ve: 'es-419',

        fr: 'fr-fr',
        it: 'it-it',
        br: 'pt-br',
    },
    ptv: {
        dk: 'da-dk',
        fo: 'da-dk',
        gl: 'da-dk',

        us: 'en-us',
        au: 'en-au',
        ca: 'en-ca',
        gb: 'en-gb',
        gg: 'en-gb',
        im: 'en-gb',
        je: 'en-gb',
        ie: 'en-ie',

        de: 'de-de',
        at: 'de-de',
        ch: 'de-de',

        es: 'es-es',
        ar: 'es-419',
        bo: 'es-419',
        cl: 'es-419',
        co: 'es-419',
        cr: 'es-419',
        do: 'es-419',
        ec: 'es-419',
        gt: 'es-419',
        hn: 'es-419',
        mx: 'es-419',
        ni: 'es-419',
        pa: 'es-419',
        pe: 'es-419',
        py: 'es-419',
        sv: 'es-419',
        uy: 'es-419',
        ve: 'es-419',

        fi: 'fi-fi',
        ax: 'fi-fi',

        fr: 'fr-fr',
        bl: 'fr-fr',
        gf: 'fr-fr',
        gp: 'fr-fr',
        mf: 'fr-fr',
        mq: 'fr-fr',
        pm: 'fr-fr',
        re: 'fr-fr',
        yt: 'fr-fr',

        it: 'it-it',
        sm: 'it-it',
        va: 'it-it',

        no: 'no-no',
        sj: 'no-no',

        br: 'pt-br',
        se: 'sv-se',
    },
} as const;

export const regions = {
    pplus: Object.keys(regionToLocaleMap.pplus),
    ptv: Object.keys(regionToLocaleMap.ptv),
};

export const locales = {
    pplus: Object.values(regionToLocaleMap.pplus),
    ptv: [Object.values(regionToLocaleMap.ptv), 'nb-no'].flat(),
};
